<!-- @format -->

<template>
  <div>
    <input
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "PlPercentInput",
  props: {
    value: [Number, String],
  },
  computed: {
    calculatedvalue() {
      return this.value * 100;
    },
  },
};
</script>
